import React from 'react';
import PropTypes from 'prop-types';

import Total from '../Display/Total';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';

import PublicIcon from 'material-ui/svg-icons/action/lock-open';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import RegistrationHistory from './RegistrationHistory';

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)',
};

const SubscriptionSegment = ({module, subscription, passMark, actions}) => {
    let subtitle = '';
    const avatarIcon = (!!module.visibility && module.visibility === 'private') ? (<PrivateIcon {...iconProps}/>) : (<PublicIcon {...iconProps}/>);
    let score = 0;

    if (!!subscription.status) {

        switch (subscription.status) {

            case 'waiting':
                subtitle = 'On waiting list';
                break;

            case 'enrolled':
                subtitle = (subscription.isAssigned ? 'Assigned' : 'Booked');

                score = Number(subscription.score);

                if (!!subscription.dateAdded) {
                    const subscriptionDate = new Date(subscription.dateAdded);
                    if (!!subscriptionDate && !isNaN(subscriptionDate.valueOf())) {
                        subtitle += ` on ${subscriptionDate.toDateString()}`;
                    }
                }

                break;

            case 'completed':

                subtitle = 'Completed';
                score = Number(subscription.score);

                if (!!subscription.dateCompleted) {
                    const completedDate = new Date(subscription.dateCompleted);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        subtitle += ` on ${completedDate.toDateString()}`;
                    }
                }
                break;

            case 'cancelled':
                subtitle = 'Cancelled';
                break;

            default:
                break;
        }
    }
    const showScore = (
        (score > 0 || passMark > 0)
        && !!subscription.status && subscription.status !== 'none' && subscription.status !== 'cancelled'
        && module.type !== 'resource' && module.type !== 'video' && module.type !== 'audio'
    );
    const showHistory = showScore && module.type === 'e-learning';

    return (
        <Card className="cent-card" key="subscriptionSegment">
            <CardHeader
                title="Enrolment"
                subtitle={subtitle}
                avatar={avatarIcon}
            />
            {showScore && (
                <CardText className="cent-card-text">
                    <Total key="score" amount={score} symbol="%" title="score" />
                </CardText>
            )}
            {(passMark > 0) && (<CardText className="cent-card-text">Required pass mark: {passMark}%</CardText>)}
            {(!!actions && actions.length > 0) && (
                <CardActions className="cent-card-actions">
                    {actions}
                </CardActions>
            )}
            {(showHistory) && (
                <CardText className="cent-card-text">
                    <RegistrationHistory {...subscription} />
                </CardText>
            )}
        </Card>
    );
};

SubscriptionSegment.propTypes = {
    module:         PropTypes.object.isRequired,
    subscription:   PropTypes.shape({
        status:         PropTypes.string,
        userId:         PropTypes.number,
        moduleId:       PropTypes.number
    }),
    progress:       PropTypes.object,
    passMark:       PropTypes.number,
    mandatory:      PropTypes.bool
};

export default SubscriptionSegment;
